import { ReactNodeViewRenderer } from '@tiptap/react';
import { EntityReference as SharedEntityReference } from '@agentteams/runner-request/ui/lib/tiptap/extensions/EntityReference';
import { EntityReferenceView } from './EntityReferenceView';

export type { EntityType } from '@agentteams/runner-request/ui/lib/tiptap/extensions/EntityReference';

// 공개 문서 등 앱 Provider 밖의 뷰어에도 Web 이동 계약을 공급한다.
export const EntityReference = SharedEntityReference.extend({
  addNodeView() {
    return ReactNodeViewRenderer(EntityReferenceView, {
      as: 'span',
      className: 'inline',
    });
  },
});
